import { useTranslation } from "react-i18next";
import { ChevronDown, Check } from "lucide-react";
import { setAppLanguage } from "@/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const LANGS = [
  { code: "fr", label: "Français" },
  { code: "en", label: "English" },
] as const;

interface LanguageSwitcherProps {
  variant?: "navbar" | "sidebar" | "settings";
}

export default function LanguageSwitcher({ variant = "navbar" }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  const current = i18n.language === "en" ? "en" : "fr";

  const triggerClass =
    variant === "sidebar"
      ? "flex items-center gap-1 px-3 py-1.5 text-xs font-semibold text-sidebar-foreground/50 hover:text-sidebar-foreground transition-colors rounded select-none cursor-pointer"
      : "flex items-center gap-0.5 text-xs font-semibold text-muted-foreground hover:text-foreground transition-colors rounded px-1.5 py-1 select-none cursor-pointer";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className={triggerClass} aria-label="Changer de langue">
          {current.toUpperCase()}
          <ChevronDown className="w-3 h-3" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[120px]">
        {LANGS.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => setAppLanguage(lang.code)}
            className="flex items-center justify-between gap-2 cursor-pointer"
          >
            <span>{lang.label}</span>
            {current === lang.code && <Check className="w-3.5 h-3.5 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
